"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedBullTVLiveVideostream1Schema = void 0;
exports.RedBullTVLiveVideostream1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/redbull_tv-live/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "RedBullTVLiveVideostream1",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:redbull_tv-live:1"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "assetId": {
                    "type": "string",
                    "description": "Asset ID from MIT mediabase asset catalogue (e.g. AA-1UPS7JDND1W12)",
                    "pattern": "^([0-9]+-[0-9]+|AA-[A-Z0-9]{13}|AA[A-Z|0-9]{18})$"
                },
                "mbEnvironment": {
                    "type": "string",
                    "description": "On which mediabase environment is the asset available (if not set, production is assumed)",
                    "enum": [
                        "production",
                        "staging"
                    ]
                },
                "videoId": {
                    "type": "string",
                    "description": "Video product ID from MIT aggregation API (e.g. AP-1M8YSM1M51W11)"
                },
                "VIN": {
                    "type": "string",
                    "description": "Video identification number from MIT mediabase asset catalogue (e.g. MI201802070142)",
                    "pattern": "^MI[0-9]+$"
                }
            },
            "required": [
                "videoId"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9yZWRidWxsX3R2LWxpdmUvMS5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSwrQkFBK0IsR0FBRztJQUM3QyxLQUFLLEVBQUUsb0ZBQW9GO0lBQzNGLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLDJCQUEyQjtJQUNwQyxNQUFNLEVBQUUsUUFBUTtJQUNoQixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sNENBQTRDO2FBQzdDO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixzQkFBc0IsRUFBRSxLQUFLO1lBQzdCLFlBQVksRUFBRTtnQkFDWixTQUFTLEVBQUU7b0JBQ1QsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSxxRUFBcUU7b0JBQ3BGLFNBQVMsRUFBRSxtREFBbUQ7aUJBQy9EO2dCQUNELGVBQWUsRUFBRTtvQkFDZixNQUFNLEVBQUUsUUFBUTtvQkFDaEIsYUFBYSxFQUFFLDJGQUEyRjtvQkFDMUcsTUFBTSxFQUFFO3dCQUNOLFlBQVk7d0JBQ1osU0FBUztxQkFDVjtpQkFDRjtnQkFDRCxTQUFTLEVBQUU7b0JBQ1QsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSxtRUFBbUU7aUJBQ25GO2dCQUNELEtBQUssRUFBRTtvQkFDTCxNQUFNLEVBQUUsUUFBUTtvQkFDaEIsYUFBYSxFQUFFLHNGQUFzRjtvQkFDckcsU0FBUyxFQUFFLFlBQVk7aUJBQ3hCO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsU0FBUzthQUNWO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFlBQVk7UUFDWixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=